<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="idCardName" placeholder="请输入身份证号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!--审核弹窗-->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisibleAudit"
      width="50%"
      :append-to-body="true"
      :before-close="cancel"
      :close-on-click-modal="false"
    >
      <el-form :inline="true" :model="from" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input v-model="from.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="from.idCard"></el-input>
        </el-form-item>
        <el-form-item label="单位性质">
          <el-input v-model="from.type"></el-input>
        </el-form-item>
        <el-form-item label="证书编号">
          <el-input v-model="from.certificateNum"></el-input>
        </el-form-item>
        <el-form-item label="证书内容">
          <el-input v-model="from.certificateContent"></el-input>
        </el-form-item>
        <el-form-item label="培训地点">
          <el-input v-model="from.place"></el-input>
        </el-form-item>
        <el-form-item label="培训等级">
          <!-- <el-input v-model="from.examinationGrade"></el-input> -->
          <el-select v-model="from.level" placeholder="请选择">
            <el-option
              v-for="item in selects"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAudit = false">取 消</el-button>
        <el-button type="primary" @click="addOrEditTraining">确 定</el-button>
      </span>
    </el-dialog>
    <el-table
      ref="multipleeeeTable"
      :data="list"
      tooltip-effect="dark"
      empty-text
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column prop="id" type="selection" width="55"></el-table-column> -->
      <el-table-column label="序号" type="index"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="idCard" label="身份证号"></el-table-column>
      <el-table-column prop="type" label="单位性质"></el-table-column>
      <el-table-column prop="certificateNum" label="证书编号"></el-table-column>
      <el-table-column prop="certificateContent" label="证书内容"></el-table-column>
      <el-table-column prop="place" label="培训地点"></el-table-column>
      <el-table-column prop="level" label="培训等级"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" size="mini" type="primary" @click="editInfo(scope.row)"></el-button>
          <el-button icon="el-icon-delete" size="mini" type="danger" @click="delInfo(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="pageIndex"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        v-show="total>0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisibleAudit: false,
      idCardName: "",
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      list: [],
      ids: [],
      title: "新增信息",
      from: {
        id: "",
        name: "",
        idCard: "",
        type: "",
        certificateNum: "",
        certificateContent: "",
        place: "",
        level: ""
      },
      selects: [
        {
          value: "初级",
          label: "初级"
        },
        {
          value: "中级",
          label: "中级"
        },
        {
          value: "高级",
          label: "高级"
        }
      ]
    };
  },
  created() {
    this.teaPeiXunList();
  },
  methods: {
    cancel() {
      this.from.id = "";
      this.from.type = "";
      this.from.name = "";
      this.from.certificateNum = "";
      this.from.certificateContent = "";
      this.from.place = "";
      this.from.level = "";
      this.from.idCard = "";
      this.dialogVisibleAudit = false;
    },
    //新增
    addInfo() {
      this.dialogVisibleAudit = true;
    },
    addOrEditTraining() {
      var that = this;
      this.$http
        .post("/api/XOrg/TeachersTraining/addOrEditTraining", {
          id: this.from.id,
          type: this.from.type,
          name: this.from.name,
          certificateNum: this.from.certificateNum,
          certificateContent: this.from.certificateContent,
          place: this.from.place,
          level: this.from.level,
          idCard: this.from.idCard
        })
        .then(rst => {
          if (rst.code == 1) {
            that.$message.success(rst.msg);
            that.cancel();
            that.teaPeiXunList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //修改
    editInfo(row) {
      this.dialogVisibleAudit = true;
      this.title = "修改信息";
      this.from.id = row.id;
      this.from.type = row.type;
      this.from.name = row.name;
      this.from.certificateNum = row.certificateNum;
      this.from.certificateContent = row.certificateContent;
      this.from.place = row.place;
      this.from.level = row.level;
      this.from.idCard = row.idCard;
    },
    delInfo(id) {
      var that = this;
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.$http
            .post("/api/XOrg/TeachersTraining/deleteteaPeiXunInfo", {
              ids: id
            })
            .then(rst => {
              if (rst.code == 1) {
                that.$message.success(rst.msg);
                that.teaPeiXunList();
              } else {
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //查询培训信息
    teaPeiXunList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/TeachersTraining/teaPeiXunList", {
          page: page,
          pageSize: this.pageSize,
          idCard: that.idCardName
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    //查询
    search() {
      this.teaPeiXunList();
    },
    onPageChangeHandler(page) {
      this.getTrainApplyList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTrainApplyList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    }
  }
};
</script>